import { Component, OnInit } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { SidebarComponent } from "./modiwlau/ui/sidebar/sidebar.component";
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [
        FaIconComponent,
        SidebarComponent,
        DatePipe,
    ],
})
export class AppComponent implements OnInit {
  cynnalAChadw: boolean;
  cynnalAChadwCychwyn: Date | null;
  cynnalAChadwGorffen: Date | null;

  ngOnInit() {
    this.gwirioYnCynnalAChadw();
  }

  gwirioYnCynnalAChadw(): void {
    const timestamp = new Date().getTime();

    fetch(`assets/cynnal-a-chadw.json?t=${timestamp}`)
      .then((response) => response.json())
      .then((config) => {
        const dyddiadAmserRwan = new Date();
        this.cynnalAChadwCychwyn = new Date(config.cychwyn);
        this.cynnalAChadwGorffen = new Date(config.gorffen);
        this.cynnalAChadw = dyddiadAmserRwan > this.cynnalAChadwCychwyn && dyddiadAmserRwan < this.cynnalAChadwGorffen;
      })
      .catch((error) => {
        console.error("Gwall nol statws cynnal a chadw", error);
      });
  }
}
